"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppContext = void 0;
const session_manager_1 = require("@agilepoint/session-manager");
const agilepoint_service_client_1 = require("../clients/agilepoint-service-client");
const configuration_1 = require("../configuration");
const defaultOptions = {
    configSource: configuration_1.ConfigSource.fromFile('/config.json'),
    configLoading: () => { },
    configLoaded: () => { }
};
async function createAppContext(options) {
    const { configSource, configLoaded, configLoading, authentication } = { ...defaultOptions, ...options };
    configLoading();
    const configuration = Object.freeze(await configSource.load());
    configLoaded({ config: configuration });
    const { agilepoint: { apiUrl, requestCredentialsMode = 'omit' }, appId } = configuration;
    const sessionManager = new session_manager_1.SessionManager(authentication);
    await sessionManager.start();
    const sessionController = (0, session_manager_1.createSessionController)(sessionManager);
    const client = new agilepoint_service_client_1.AgilePointServiceClient({
        baseUrl: apiUrl,
        headers: { appID: appId },
        credentials: requestCredentialsMode,
        sessionController,
        getAgilePointConfiguration: () => configuration.agilepoint
    });
    return {
        configuration,
        sessionController,
        client
    };
}
exports.createAppContext = createAppContext;
//# sourceMappingURL=app-context.js.map